import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBubbleTransition } from './BubbleTransition';

function Footer({ isRegisterPage }) {
  const trigger  = useBubbleTransition();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    trigger(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
  };

  const goTo = (path) => {
    trigger(() => navigate(path));
  };

  return (
    <footer className="page-footer">
      <div className="footer-wave"></div>
      <div className="footer-main">
        <div className="footer-content">

          {/* About section */}
          <div className="footer-column">
            <h3 className="footer-heading">Code It Up 6.0</h3>
            <p className="footer-description">
              Dive into the ultimate underwater coding hackathon! Code It Up brings together creative minds for an epic adventure of innovation, teamwork, and fun.
            </p>
            <div className="footer-social-links">
              <a href="https://www.instagram.com/code_it_up_6.0/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://www.facebook.com/profile.php?id=100082526770227" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {isRegisterPage ? (
                <>
                  <li><button onClick={() => goTo('/')}>Home</button></li>
                  <li><button onClick={() => goTo('/')}>About</button></li>
                  <li><button onClick={() => goTo('/')}>Team</button></li>
                  <li><button onClick={() => goTo('/')}>Ambassadors</button></li>
                  <li><button onClick={() => goTo('/')}>Sponsors</button></li>
                  <li><button onClick={() => goTo('/')}>Past Editions</button></li>
                </>
              ) : (
                <>
                  <li><button onClick={() => scrollTo('home')}>Home</button></li>
                  <li><button onClick={() => scrollTo('about')}>About</button></li>
                  <li><button onClick={() => scrollTo('team')}>Team</button></li>
                  <li><button onClick={() => scrollTo('ambassadors')}>Ambassadors</button></li>
                  <li><button onClick={() => scrollTo('sponsors')}>Sponsors</button></li>
                  <li><button onClick={() => scrollTo('editions')}>Past Editions</button></li>
                  <li><button onClick={() => goTo('/register')}>Register Now</button></li>
                </>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-column">
            <h3 className="footer-heading">Contact Us</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <span className="footer-contact-icon">📍</span>
                <span>Bizerte, Tunisia</span>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon">📧</span>
                <a href="mailto:code.it.up.6.0@gmail.com">code.it.up.6.0@gmail.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Code It Up 6.0. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;